import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { getCategoryToday, getCategoryTodayTemplate, getChildCategoryToday } from '../../api';
import { isEmpty } from '@/utils';
export default {
  name: 'cake_today_config',
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    styleId: [String, Number],
    source: String,
    // template:模板库
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      menuList: [],
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        category_id: [{
          required: true,
          message: '菜单不可为空',
          trigger: 'change'
        }],
        imageurl: [{
          required: true,
          message: '图片不可为空',
          trigger: 'change'
        }]
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {}
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.$set(this.value.config, 'imageurl', path);
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      this.showPictureLibrary = true;
    },
    getMenuList: function getMenuList() {
      var _this2 = this;
      /**
       * status === 0 正常状态
       * 菜单状态为隐藏或删除时 添加disabled属性
       * falg : 一级状态为删除或隐藏时,子级同步全部置灰
       */
      var _addDisableProperty = function addDisableProperty(obj, flag) {
        var id = obj.id.split(':')[1] || '';
        obj.disabled = flag || obj.status !== 0 && obj.status !== 1;
        obj.show_name = "".concat(obj.name).concat(id ? "ID".concat(id) : '').concat(obj.alias_name ? "\uFF08".concat(obj.alias_name, "\uFF09") : '');
        if (Array.isArray(obj.childrens)) {
          obj.childrens = obj.childrens.map(function (child) {
            return _addDisableProperty(child, obj.disabled);
          });
        }
        return obj;
      };
      var _this$info = this.info,
        _this$info$module = _this$info.module,
        module = _this$info$module === void 0 ? '' : _this$info$module,
        _this$info$channel_id = _this$info.channel_id,
        channel_id = _this$info$channel_id === void 0 ? '' : _this$info$channel_id,
        _this$info$customer_i = _this$info.customer_id,
        customer_id = _this$info$customer_i === void 0 ? '' : _this$info$customer_i,
        _this$info$page_sourc = _this$info.page_source,
        page_source = _this$info$page_sourc === void 0 ? '' : _this$info$page_sourc;
      var req = getCategoryToday;
      var params = {
        styleId: this.styleId
      };
      if (this.source === 'template') {
        req = getCategoryTodayTemplate;
        if (page_source === 'channel') {
          params.channel_id = channel_id;
        }
      } else if (this.source === 'children') {
        req = getChildCategoryToday;
        params = _objectSpread(_objectSpread({}, params), {}, {
          channel_id: channel_id,
          customer_id: customer_id
        });
      }
      req(params, module, page_source).then(function (res) {
        _this2.menuList = res.data.map(function (item) {
          return _addDisableProperty(item);
        });
      });
    },
    upload: function upload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url) {
      this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
        imageurl: "".concat(this.$ossurl).concat(url)
      }));
    },
    deleteImg: function deleteImg() {
      var _this3 = this;
      if (!this.value.config.imageurl) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this3.$set(_this3.value, 'config', _objectSpread(_objectSpread({}, _this3.value.config), {}, {
          imageurl: ''
        }));
      });
    }
  },
  created: function created() {
    this.getMenuList();
    this.getPicture();
    if (isEmpty(this.value.config)) {
      this.$set(this.value, 'config', {
        imageurl: this.value.default_value.default_imageurl
      });
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
  }
};